import { useState } from "react";
import CircularGraphWithIcon from "../components/Graph/CircularGraph";
import {
  FormControl,
  LinearProgress,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";

import LinearProgressBar from "../components/Graph/LinearProgress";
import LineChartComponent from "../components/Graph/LineChart";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
const itemsPerPage = 5;
export const Community = () => {
  const localData = localStorage.getItem("userdata") ||JSON.stringify({accessCode:""}) ;
  const access_code = JSON.parse(localData).accessCode ;
  const [page, setPage] = useState(1);

  const handleChange = (event: any, value: any) => {
    setPage(value);
  };
  const data: string | any[] = ["Apple", "Mango"];
  const tableData = [
    { activity: "Deep Breathing", percentage: 38 },
    { activity: "Guided Imagery", percentage: 20 },
    { activity: "Guided Massage", percentage: 11 },
  ];
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentPageData = data.slice(startIndex, endIndex);
  return (
    <div>
      <div style={{ display: "flex", marginBottom: "15px" }}>
        <div
          style={{
            flex: 1,
            backgroundColor: "#f0efe9",
            marginRight: "20px",
            borderRadius: "8px",
          }}
        >
          <div
            style={{
              color: "#b0aeb1",
              fontSize: "12px",
              textAlign: "right",
              padding: "12px",
              textDecoration: "underline",
              cursor: "pointer",
              borderBottom: "1px solid white",
            }}
          >
            What does this data mean?
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "20px 20px 15px 20px",
              alignItems: "center",
            }}
          >
            <div>{access_code? "Employees":"Users"} Onboarded</div>
            <div style={{ fontSize: "24px", color: "#e86943" }}>489</div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 20px 25px 20px",
              alignItems: "center",
            }}
          >
            <div>{access_code? "Employees":"Users"} Engaging</div>
            <div style={{ fontSize: "24px", color: "#4fb8f3" }}>165</div>
          </div>
          <div style={{ padding: "0 20px 40px 20px" }}>
            <CircularGraphWithIcon />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 20px 25px 20px",
              alignItems: "center",
            }}
          >
            <div style={{ fontSize: "12px", color: "#908388" }}>
              Family Members Engaging
            </div>
            <div>0/0</div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 20px 0 20px",
              alignItems: "center",
              borderTop: "1px solid white",
              fontSize: "14px",
            }}
          >
            <div
              style={{
                flex: 1,
                borderRight: "1px solid white",
                padding: "10px 0",
                color: "#908388",
              }}
            >
              + Add employee
            </div>
            <div
              style={{
                flex: 1,
                textAlign: "center",
                borderLeft: "1px solid white",
                padding: "10px 0",
                color: "#e7765f",
              }}
            >
              Send activation reminder
            </div>
          </div>
        </div>
        <div
          style={{
            flex: 1,
            backgroundColor: "#fff",
            marginRight: "20px",
            borderRadius: "8px",
          }}
        >
          <div style={{ padding: " 25px 20px 5px 20px" }}>
            The Manoshala Happiness Test
          </div>
          <div
            style={{ fontSize: "12px", color: "#ccbeb6", padding: "0 20px" }}
          >
            Survey sent: 7th Nov 2023
          </div>
          <div style={{ padding: "20px 0" }}>
            <CircularGraphWithIcon />
          </div>
          <div
            style={{
              textAlign: "center",
              fontSize: "24px",
              fontWeight: "bold",
              paddingBottom: "10px",
            }}
          >
            0.37
          </div>
          <div
            style={{
              textAlign: "center",
              fontSize: "16px",
              backgroundColor: "#fff7d0",
              color: "#b0751b",
              width: "100px",
              margin: "auto",
              borderRadius: "20px",
              padding: "8px",
            }}
          >
            Moderate
          </div>
          <div
            style={{
              textAlign: "center",
              padding: "25px 0 20px 0",
              fontSize: "14px",
              color: "#e7765f",
            }}
          >
            16 {access_code? "Employees":"Users"} took this survey
          </div>
          <div
            style={{
              color: "#aea9ad",
              textAlign: "center",
              borderTop: "0.3px solid #aea9ad",
              fontSize: "12px",
              textDecoration: "underline",
              cursor: "pointer",
              padding: "15px 0",
            }}
          >
            What does this mean for you?
          </div>
        </div>
        <div
          style={{
            flex: 1,
            backgroundColor: "#fff",
            marginRight: "20px",
            borderRadius: "8px",
          }}
        >
          <div style={{ padding: " 25px 20px 5px 20px" }}>
            The Manoshala Happiness Test 2
          </div>
          <div
            style={{ fontSize: "12px", color: "#ccbeb6", padding: "0 20px" }}
          >
            Survey sent: 23rd Nov 2023
          </div>
          <div style={{ padding: "20px 0" }}>
            <CircularGraphWithIcon />
          </div>
          <div
            style={{
              textAlign: "center",
              fontSize: "24px",
              fontWeight: "bold",
              paddingBottom: "10px",
            }}
          >
            0.59
          </div>
          <div
            style={{
              textAlign: "center",
              fontSize: "16px",
              backgroundColor: "#fff7d0",
              color: "#b0751b",
              width: "100px",
              margin: "auto",
              borderRadius: "20px",
              padding: "8px",
            }}
          >
            Moderate
          </div>
          <div
            style={{
              textAlign: "center",
              padding: "25px 0 20px 0",
              fontSize: "14px",
              color: "#e7765f",
            }}
          >
            10 {access_code? "Employees":"Users"} took this survey
          </div>
          <div
            style={{
              color: "#aea9ad",
              textAlign: "center",
              borderTop: "0.3px solid #aea9ad",
              fontSize: "12px",
              textDecoration: "underline",
              cursor: "pointer",
              padding: "15px 0",
            }}
          >
            What does this mean for you?
          </div>
        </div>
      </div>

      <div style={{ padding: "0 15px", backgroundColor: "#fff" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "15px 0",
          }}
        >
          <div style={{ fontSize: "20px" }}>Consultation</div>
          <div>
            <FormControl>
              <Select
                style={{ width: "150px", height: "40px", borderRadius: "8px" }}
                value={"all"}
                // onChange={handleChange}
              >
                <MenuItem value="all">All time</MenuItem>
                <MenuItem value="last_30">Last 30 days</MenuItem>
                <MenuItem value="last_60">Last 60 days</MenuItem>
                <MenuItem value="last_90">Last 90 days</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
        <div style={{ display: "flex", marginBottom: "20px" }}>
          <div
            style={{
              flex: 1.75,
              borderTop: "1px solid #eeeff2",
              borderRight: "1px solid #eeeff2",
            }}
          >
            <div style={{ padding: "15px" }}>
              <div style={{ padding: "15px 0 20px 0" }}>
                No. of {access_code? "Employees":"Users"} taking sessions
              </div>
              <div>
                <div>
                  <LinearProgressBar
                    progress={465}
                    total={465}
                    color={"#3baff6"}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginRight: "60px",
                    fontSize: "14px",
                    color: "#a7aaad",
                  }}
                >
                  <div>0</div>
                  <div>465</div>
                </div>
              </div>
            </div>
            <div style={{ padding: "15px" }}>
              <div style={{ padding: "0 0 20px 0" }}>
                Total no. of sessions booked
              </div>
              <div>
                <div>
                  <LinearProgressBar
                    progress={200}
                    total={465}
                    color={"#4a51a7"}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginRight: "60px",
                    fontSize: "14px",
                    color: "#a7aaad",
                  }}
                >
                  <div>0</div>
                  <div>465</div>
                </div>
              </div>
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#a7aaad",
                padding: "20px 10px 15px 15px",
                borderTop: "1px solid #eeeff2 ",
              }}
            >
              These are {access_code? "employees":"users"} that are reaching out to a mental health{" "}
              <br /> professional to talk about their concerns.
            </div>
          </div>
          <div
            style={{ flex: 3, padding: "10px", borderTop: "1px solid #eeeff2" }}
          >
            <div style={{ paddingLeft: "30px" }}>
              No. of sessions booked over time
            </div>
            <div>
              <LineChartComponent />
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: "flex" }}>
        <div style={{ backgroundColor: "#fff", marginRight: "20px" }}>
          <div
            style={{
              fontSize: "20px",
              padding: "15px",
              borderBottom: "1px solid #eeeff2",
            }}
          >
            Recommended Activities
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "15px",
              marginTop: "15px",
            }}
          >
            <div>No. of {access_code? "employees":"users"} engaging with activities</div>
            <div style={{ fontSize: "24px" }}>41</div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 15px 15px 15px",
            }}
          >
            <div>Most popular activities</div>
            <div style={{ color: "#e76943" }}>112 times activities started</div>
          </div>
          <div style={{ overflow: "auto", height: "200px" }}>
            <TableContainer>
              <Table>
                <TableBody>
                  {tableData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell
                        sx={{ fontWeight: "500", borderBottom: "none" }}
                      >
                        {row.activity}
                      </TableCell>
                      <TableCell sx={{ width: "300px", borderBottom: "none" }}>
                        <LinearProgress
                          variant="determinate"
                          value={row.percentage}
                          sx={{
                            width: "100%",
                            height: "15px",
                            borderRadius: "0 5px 5px 0",
                            backgroundColor: "#f7f7f7",
                            "& .MuiLinearProgress-bar1Determinate": {
                              backgroundColor: `#3baff6`,
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell style={{ borderBottom: "none" }}>
                        {row.percentage}%
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div
            style={{
              textAlign: "center",
              borderTop: "1px solid #eeeff2",
              padding: "15px",
              position: "relative",
            }}
          >
            <div
              style={{
                textAlign: "center",
                marginTop: "-28px",
                marginLeft: "36%",
                backgroundColor: "#fff",
                cursor: "pointer",
                position: "absolute",
                display: "flex",
              }}
            >
              <Typography>Show more</Typography>
              <div>
                <KeyboardArrowDownRoundedIcon />
              </div>
            </div>
          </div>
        </div>
        <div style={{ backgroundColor: "#fff", marginRight: "20px" }}>
          <div
            style={{
              fontSize: "20px",
              padding: "15px",
              borderBottom: "1px solid #eeeff2",
            }}
          >
            Resources
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "15px",
              marginTop: "15px",
            }}
          >
            <div>No. of {access_code? "employees":"users"} reading the resources</div>
            <div style={{ fontSize: "24px" }}>37</div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 15px 15px 15px",
            }}
          >
            <div>Most popular activities</div>
            <div style={{ color: "#e76943" }}>54 resources read</div>
          </div>
          <div style={{ overflow: "auto", height: "200px" }}>
            <TableContainer>
              <Table>
                <TableBody>
                  {tableData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell
                        sx={{ fontWeight: "500", borderBottom: "none" }}
                      >
                        {row.activity}
                      </TableCell>
                      <TableCell sx={{ width: "300px", borderBottom: "none" }}>
                        <LinearProgress
                          variant="determinate"
                          value={row.percentage}
                          sx={{
                            width: "100%",
                            height: "15px",
                            borderRadius: "0 5px 5px 0",
                            backgroundColor: "#f7f7f7",
                            "& .MuiLinearProgress-bar1Determinate": {
                              backgroundColor: `#3baff6`,
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell style={{ borderBottom: "none" }}>
                        {row.percentage}%
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div
            style={{
              textAlign: "center",
              borderTop: "1px solid #eeeff2",
              padding: "15px",
              position: "relative",
            }}
          >
            <div
              style={{
                textAlign: "center",
                marginTop: "-28px",
                marginLeft: "36%",
                backgroundColor: "#fff",
                cursor: "pointer",
                position: "absolute",
                display: "flex",
              }}
            >
              <Typography>Show more</Typography>
              <div>
                <KeyboardArrowDownRoundedIcon />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
